
const mockGetDerivedPolicyForToken = () => {
    return {
        policy: {
            objectstores  : [{ name:'*', permission: 'RW' }],
            groups        : [],
            mapnotes      : [{ name: '*', permission: 'RW' }],
            assets        : [],
            internalTools : [],
            mapsyndication: [],
            mapsondisplay : [],
            people_insight_dashboards: [],
        },
    }
}


const MockLliam = { getDerivedPolicyForToken: () => mockGetDerivedPolicyForToken() }

export { MockLliam }
